import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultCreditAlertsUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultCreditAlertsUsers');

export const accountSearchResultCreditAlertsUsersActions = accountSearchResultCreditAlertsUsersSlice.actions;

const accountSearchResultCreditAlertsUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.creditAlertsUsers.cache;
export const accountSearchResultCreditAlertsUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.creditAlertsUsers;
export const accountSearchResultCreditAlertsUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultCreditAlertsUsersCacheSelector,
    accountSearchResultStateSelector,
);
